import { isAxiosError } from "axios"

import { Spinner } from "components/Spinner"
import { Pages } from "modules/BookingCommon/common/constants"
import { TIME_REQUEST_STATUSES } from "utils/constants"
import { CardsPage } from "modules/BookingCommon/components"
import { INITIATOR } from "modules/BookingCommon/components/DatePicker/constants"
import {
    createdTimeRequestLoader,
    createdBookingLoader,
    createdDepositLoader,
} from "modules/BookingCommon/common/queries"
import { SessionDateTimePage } from "modules/Booking/SessionDatePage"
import { FormPage } from "modules/Booking/FormPage"
import { PaymentPage } from "modules/Booking/PaymentPage"
import { useBookingContext } from "modules/Booking/BookingContext"
import { ErrorPage } from "modules/Booking/ErrorPage"
import { FormPageProvider } from "modules/Booking/FormPage/common/FormPageContext"
import { TimeRequestModal } from "modules/Booking/components"
import { useGetCurrentPage } from "modules/Booking/common/hooks/useGetCurrentPage"

export function Content() {
    const [
        { serviceGroups, serviceGroup, psy, currency, hasSlots, isLoading },
        {
            setServiceGroup,
            setIsChooseManuallyService,
            setCurrency,
            nextPage,
            handleClickButtonInCards,
            setPage,
        },
    ] = useBookingContext()
    const isBookingLoading = createdBookingLoader.useIsLoading()
    const bookingHash = createdBookingLoader.getHash()
    const depositHash = createdDepositLoader.getHash()
    const isDepositLoading = createdDepositLoader.useIsLoading()
    const timeRequestHash = createdTimeRequestLoader.getHash()
    const { data: timeRequestResponse, error } = createdTimeRequestLoader.useGet(timeRequestHash)
    const timeRequestStatus = timeRequestResponse?.status
    const currentPage = useGetCurrentPage()
    const isTimeRequestLoading = createdTimeRequestLoader.useIsLoading()
    const showSpinner =
        !!isBookingLoading || !!isTimeRequestLoading || !!isDepositLoading || isLoading
    const hash = bookingHash || timeRequestHash || depositHash

    if (showSpinner) {
        return (
            <div className="redesign-container">
                <Spinner />
            </div>
        )
    }

    if (
        hash &&
        (timeRequestStatus === TIME_REQUEST_STATUSES.CANCELLED_WITHOUT_PAYMENT ||
            timeRequestStatus === TIME_REQUEST_STATUSES.ERROR ||
            (isAxiosError(error) && error.response?.status === 404))
    ) {
        if (timeRequestStatus === TIME_REQUEST_STATUSES.CREATED) setPage(Pages.PAYMENT)

        return (
            <ErrorPage
                headline="Произошла ошибка"
                secondary="Обратитесь в службу поддержки."
                buttonText="Выбрать время"
            />
        )
    }

    return (
        <>
            {currentPage === Pages.CARDS && (
                <CardsPage
                    serviceGroups={serviceGroups}
                    serviceGroup={serviceGroup}
                    psy={psy}
                    currency={currency}
                    showDiscount={true}
                    initiator={INITIATOR.CLIENT}
                    hasSlots={hasSlots}
                    onChangeCurrency={setCurrency}
                    onChangeServiceGroup={setServiceGroup}
                    onChangeIsChooseManuallyService={setIsChooseManuallyService}
                    nextPage={nextPage}
                    onClickNextPage={handleClickButtonInCards}
                />
            )}
            {currentPage === Pages.SESSION_DATE && <SessionDateTimePage />}
            {currentPage === Pages.FORM && (
                <FormPageProvider>
                    <FormPage />
                </FormPageProvider>
            )}
            {(currentPage === Pages.PAYMENT ||
                (currentPage === undefined && (bookingHash || timeRequestHash || depositHash))) && (
                <PaymentPage />
            )}
            <TimeRequestModal />
        </>
    )
}
